import script from "./ProjectPlanSettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectPlanSettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectPlanSettingsPage.vue?vue&type=style&index=0&id=3be735c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be735c7"]])

export default __exports__